import * as React from "react";
import Svg, { LinearGradient, Stop, Path, Circle } from "react-native-svg";

export default function SocialIconInstagram({ inline, locked }) {
  const rand1 = Math.random();
  /**
   * IDs cannot be shared, otherwise they will disappear upon next screens (because duplicate ids from other screen so add random)
   */
  return (
    <Svg
      style={{
        flex: 1,
        maxWidth: 30,
        maxHeight: 30,
        width: 44,
        height: 44,
      }}
      height="100%"
      width="100%"
      top={0}
      left={0}
      viewBox="0 0 400 400"
      id="Layer_1"
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <LinearGradient
        gradientUnits="userSpaceOnUse"
        id={"SVGID_1_" + rand1}
        x1={146.4465}
        x2={853.5535}
        y1={853.5535}
        y2={146.4465}
      >
        <Stop offset={0} stopColor="#ffd521" />
        <Stop offset={0.05510481} stopColor="#ffd020" />
        <Stop offset={0.1241} stopColor="#fec01e" />
        <Stop offset={0.2004} stopColor="#fca71b" />
        <Stop offset={0.2821} stopColor="#fa8316" />
        <Stop offset={0.3681} stopColor="#f85510" />
        <Stop offset={0.4563} stopColor="#f51e09" />
        <Stop offset={0.5} stopColor="#f30005" />
        <Stop offset={0.5035} stopColor="#f20007" />
        <Stop offset={0.5966} stopColor="#e1003b" />
        <Stop offset={0.6879} stopColor="#d30067" />
        <Stop offset={0.7757} stopColor="#c70088" />
        <Stop offset={0.8589} stopColor="#bf00a0" />
        <Stop offset={0.9357} stopColor="#bb00af" />
        <Stop offset={1} stopColor="#b900b4" />
      </LinearGradient>
      <Path
        d="M500 1000C223.9 1000 0 776.1 0 500S223.9 0 500 0s500 223.9 500 500-223.9 500-500 500z"
        fill={"url(#SVGID_1_" + rand1 + ")"}
      />
      <Path
        className="st1"
        fill="white"
        d="M500 220.2c91.1 0 101.9.3 137.9 2 33.3 1.5 51.4 7.1 63.4 11.8 15.9 6.2 27.3 13.6 39.2 25.5 11.9 11.9 19.3 23.3 25.5 39.2 4.7 12 10.2 30.1 11.8 63.4 1.6 36 2 46.8 2 137.9s-.3 101.9-2 137.9c-1.5 33.3-7.1 51.4-11.8 63.4-6.2 15.9-13.6 27.3-25.5 39.2-11.9 11.9-23.3 19.3-39.2 25.5-12 4.7-30.1 10.2-63.4 11.8-36 1.6-46.8 2-137.9 2s-101.9-.3-137.9-2c-33.3-1.5-51.4-7.1-63.4-11.8-15.9-6.2-27.3-13.6-39.2-25.5-11.9-11.9-19.3-23.3-25.5-39.2-4.7-12-10.2-30.1-11.8-63.4-1.6-36-2-46.8-2-137.9s.3-101.9 2-137.9c1.5-33.3 7.1-51.4 11.8-63.4 6.2-15.9 13.6-27.3 25.5-39.2 11.9-11.9 23.3-19.3 39.2-25.5 12-4.7 30.1-10.2 63.4-11.8 36-1.7 46.8-2 137.9-2m0-61.5c-92.7 0-104.3.4-140.7 2.1-36.3 1.7-61.1 7.4-82.9 15.9C254 185.3 234.9 197 216 216c-19 19-30.6 38-39.4 60.5-8.4 21.7-14.2 46.5-15.9 82.9-1.7 36.4-2.1 48-2.1 140.7 0 92.7.4 104.3 2.1 140.7 1.7 36.3 7.4 61.1 15.9 82.9C185.3 746 197 765.1 216 784c19 19 38 30.6 60.5 39.4 21.7 8.4 46.5 14.2 82.9 15.9 36.4 1.7 48 2.1 140.7 2.1s104.3-.4 140.7-2.1c36.3-1.7 61.1-7.4 82.9-15.9C746 814.7 765.1 803 784 784c19-19 30.6-38 39.4-60.5 8.4-21.7 14.2-46.5 15.9-82.9 1.7-36.4 2.1-48 2.1-140.7s-.4-104.3-2.1-140.7c-1.7-36.3-7.4-61.1-15.9-82.9C814.7 254 803 234.9 784 216c-19-19-38-30.6-60.5-39.4-21.7-8.4-46.5-14.2-82.9-15.9-36.3-1.6-47.9-2-140.6-2z"
      />
      <Path
        className="st1"
        fill="white"
        d="M500 324.7c-96.8 0-175.3 78.5-175.3 175.3S403.2 675.3 500 675.3 675.3 596.8 675.3 500 596.8 324.7 500 324.7zm0 289.1c-62.8 0-113.8-50.9-113.8-113.8s51-113.8 113.8-113.8S613.8 437.1 613.8 500s-51 113.8-113.8 113.8z"
      />
      <Circle fill="white" className="st1" cx={682.2} cy={317.8} r={41} />
    </Svg>
  );
}
